// @flow
import React from 'react';
import type { Element, ChildrenArray } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { Heading } from '../Heading.js';
import { productColor } from '../designSystem.js';
import { Text } from '../Text.js';
import bullet from './bullet.svg';

// NOTE
// Ideally there would be a concordance between TSOEssentialUnderstanding
// and SSOEssentialQuestionsList:
//
// <SSOEssentialQuestionsList>
//   <SSOEssentialQuestion>
//
// <TSOEssentialUnderstandingList>
//   <TSOEssentialUnderstanding>
//
// But this requires a breaking change to TSOEssentialUnderstanding
// since it currently serves the role of the "TSOEssentialUnderstandingList"
// At this time, we don't have the bandwidth to perform this breaking
// change so for now TSOEssentialUnderstanding will support a series
// of child <Text> elements that will behaviour in a comparable manner
// to a <TSOEssentialUnderstandingList> + <TSOEssentialUnderstanding> pattern
export function TSOEssentialUnderstanding(props: {|
  children: ChildrenArray<Element<typeof Text>>,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    TSOEssentialUnderstanding,
  );

  if (failedValidation) return null;

  const _children = React.Children.toArray(props.children);

  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <Heading>Essential understanding</Heading>
      <div style={{ fontFamily: 'Proxima Nova' }}>
        {_children.length > 1 ? (
          <ul style={{ paddingLeft: 16 }}>
            {_children.map((child, i) => (
              <li
                key={i}
                style={{
                  listStylePosition: 'outside',
                  listStyleImage: `url('${bullet}')`,
                  marginBottom: 8,
                }}
              >
                {child}
              </li>
            ))}
          </ul>
        ) : (
          _children
        )}
      </div>
    </div>
  );
}

TSOEssentialUnderstanding.spec = {
  children: t.minimumCount(1, t.elementType(Text)),
};
